import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  USER_DETAIL,
  USER_DETAIL_SUCCESS,
  USER_DETAIL_ERROR,
  CLIENT_DETAIL,
  CLIENT_DETAIL_SUCCESS,
  CLIENT_DETAIL_ERROR,
  CLIENT_DETAILS,
  CLIENT_DETAILS_SUCCESS,
  CLIENT_DETAILS_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
        error: "",
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
      case USER_DETAIL:
        return { ...state, loading: true }
      case USER_DETAIL_SUCCESS:
        return { ...state, userdetail: action.payload, loading: false }
      case USER_DETAIL_ERROR:
        return { ...state, loading: false }
       case CLIENT_DETAILS:
        return { ...state, loading: true }
      case CLIENT_DETAILS_SUCCESS:
        return { ...state, clientDetails: action.payload, loading: false }
      case CLIENT_DETAILS_ERROR:
        return { ...state, loading: false }
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
